import React from "react";
import { useI18n } from "../../lib/i18n.jsx";
import { track } from "../../lib/analytics.js";

const CANALES = [
  {
    key: "telefono",
    icon: "fa-solid fa-phone",
    valor: "(+34) 933 80 15 96",
    href: "tel:+34933801596",
  },
  {
    key: "whatsapp",
    icon: "fa-brands fa-whatsapp",
    valor: "(+34) 637 73 73 39",
    href: "https://wa.me/34637737339",
    externo: true,
  },
  {
    key: "email",
    icon: "fa-solid fa-envelope",
    valor: "info@euzerone.com",
    href: "mailto:info@euzerone.com",
  },
];

export default function Contacto({ onOpenQuote }) {
  const { t } = useI18n();

  return (
    <section
      id="contacto"
      className="py-24 lg:py-32 bg-[#f7f7f4]"
      data-testid="contacto-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="eu-data-label mb-4">
            <i className="fa-solid fa-comments mr-2"></i>
            {t.contacto.eyebrow}
          </div>
          <h2 className="font-display text-4xl lg:text-5xl text-[#133322] leading-tight tracking-tight">
            {t.contacto.title}
          </h2>
          <p className="mt-4 text-[#5c6b61] text-base lg:text-lg">
            {t.contacto.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CANALES.map((c) => (
            <a
              key={c.key}
              href={c.href}
              {...(c.externo
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
              onClick={() => track("contacto_click", { canal: c.key })}
              className="eu-card p-8 flex flex-col group hover:shadow-[0_24px_50px_rgba(19,51,34,0.10)] transition-shadow"
              data-testid={`contacto-${c.key}`}
            >
              <span className="h-11 w-11 rounded-full bg-[#b45f3e]/10 flex items-center justify-center mb-6">
                <i className={`${c.icon} text-[#b45f3e]`}></i>
              </span>
              <div className="eu-data-label mb-2">
                {t.contacto.canales[c.key].label}
              </div>
              <div className="font-display text-2xl text-[#133322] leading-snug group-hover:text-[#b45f3e] transition-colors">
                {c.valor}
              </div>
              <p className="mt-3 text-[#5c6b61] text-sm leading-relaxed">
                {t.contacto.canales[c.key].nota}
              </p>
            </a>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 border-t border-[#e2e6df] pt-8">
          <div className="flex items-center gap-3 text-[#5c6b61]">
            <i className="fa-solid fa-location-dot text-[#b45f3e]"></i>
            <span className="text-sm">{t.contacto.sede}</span>
          </div>
          <button
            onClick={() => {
              track("contacto_cta_quote");
              onOpenQuote?.();
            }}
            className="inline-flex items-center gap-2 bg-[#133322] hover:bg-[#1c4d33] text-[#f7f7f4] rounded-full px-7 py-3 font-medium transition self-start sm:self-auto"
            data-testid="contacto-quote-btn"
          >
            <i className="fa-solid fa-leaf"></i>
            {t.nav.quote}
          </button>
        </div>
      </div>
    </section>
  );
}
